import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Styles from "./DashboardTotalSales.module.css";
import { getTotalSalesAction } from "../../../../store/actions/dashboard/DashboardActions";
import { useNavigate } from "react-router-dom";
import ShimmerLoader from "../../../pages/ShimmerLoader/ShimmerLoader";
import currenyFormat from "../../common/currentFormat";

const DashboardTotalSales = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { total_sales, loading, error } = useSelector((state) => state.dashBoardTotalSales);
  useEffect(() => {
    dispatch(getTotalSalesAction({}, navigate));
  }, [dispatch]);

  if (loading) {
    return (
      <>
        <ShimmerLoader width='30%' height='10%' count={1} />
      </>
    );
  }
  if (!loading && total_sales) {
    return (
      <>
        <div className='d-flex align-items-center border-0 px-3'>
          <div className='rounded-circle bg-primary d-flex  align-items-center justify-content-center' style={{ height: "48px", width: "48px" }}>
            <svg width='25' height='23' viewBox='0 0 25 23' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M6.63325 22.6667L4.99992 21.0333L13.0499 12.9542L17.1333 17.0375L23.1708 11L24.8333 12.6625L17.1333 20.3333L13.0499 16.25L6.63325 22.6667ZM2.66659 21.5C2.02492 21.5 1.47561 21.2715 1.01867 20.8146C0.561724 20.3576 0.333252 19.8083 0.333252 19.1667V2.83333C0.333252 2.19167 0.561724 1.64236 1.01867 1.18542C1.47561 0.728472 2.02492 0.5 2.66659 0.5H18.9999C19.6416 0.5 20.1909 0.728472 20.6478 1.18542C21.1048 1.64236 21.3333 2.19167 21.3333 2.83333V7.73333H2.66659V21.5ZM2.66659 5.4H18.9999V2.83333H2.66659V5.4Z' fill='#F6F6F6' />
            </svg>
          </div>
          <div className={`${Styles.statistics_number} d-block py-3 ps-4 align-items-center justify-content-center`}>
            <p>Total Sales</p>
            {/* <p className='text-primary fs-4'>₹ {total_sales?.total_sales?.toFixed(2)}</p> */}
            {/* <p className='text-primary fs-4'>₹ {total_sales?.total_sales ? total_sales.total_sales.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}</p> */}
            <p className='text-primary fs-4'>{currenyFormat(total_sales?.total_sales)}</p>
          </div>
        </div>
      </>
    );
  }
};

export default DashboardTotalSales;
